module.exports = __webpack_public_path__ + "static/img/banner-empleo-interior-1024x768.9490927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-empleos/banner-empleo-interior-1024x768.jpg
// module id = kQaX
// module chunks = 47